export const CLIENT_TYPES = {
 CLIENT_SELECTED_TREATMENT_PLAN_ID:"CLIENT_SELECTED_TREATMENT_PLAN_ID",
 CLIENT_GET_CAP_SERVICES:"CLIENT_GET_CAP_SERVICES",
 CLIENT_SAVE_CAP_SERVICES:"CLIENT_SAVE_CAP_SERVICES",
 CLIENT_TP_SELECTED_TAB_INACTIVE_ACTIVE:"CLIENT_TP_SELECTED_TAB_INACTIVE_ACTIVE",
 CLIENT_GET_GENDER_LIST: "CLIENT_GET_GENDER_LIST",
 CLIENT_SAVE_GENDER_LIST: "CLIENT_SAVE_GENDER_LIST",
 CLIENT_GET_STATE_LIST: "CLIENT_GET_STATE_LIST",
 CLIENT_SAVE_STATE_LIST: "CLIENT_SAVE_STATE_LIST",
 GET_AUTH_SERVICE_REVIEWS_REQUEST: "GET_AUTH_SERVICE_REVIEWS_REQUEST",
 SAVE_AUTH_SERVICE_REVIEWS_REQUEST: "SAVE_AUTH_SERVICE_REVIEWS_REQUEST",
 CONTACT_NOTES_FILTERS: "CONTACT_NOTES_FILTERS",
 UPDATE_GOAL_DATES: "UPDATE_GOAL_DATES",
 SAVE_UPDATE_GOAL_DATES: "SAVE_UPDATE_GOAL_DATES",
 GET_CLIENT_PARENT_INFO: "GET_CLIENT_PARENT_INFO",
 SAVE_CLIENT_PARENT_INFO: "SAVE_CLIENT_PARENT_INFO",
 GET_DIAGNOSIS_EDUCATION: "GET_DIAGNOSIS_EDUCATION",
 SAVE_DIAGNOSIS_EDUCATION: "SAVE_DIAGNOSIS_EDUCATION",
 GET_MEDICATION_EDUCATION: "GET_MEDICATION_EDUCATION",
 SAVE_MEDICATION_EDUCATION: "SAVE_MEDICATION_EDUCATION",
 GET_CLIENT_CONTACT_INFORMATION_BY_EVENT: "GET_CLIENT_CONTACT_INFORMATION_BY_EVENT",
 SAVE_CLIENT_CONTACT_INFORMATION_BY_EVENT: "SAVE_CLIENT_CONTACT_INFORMATION_BY_EVENT",
 GET_CLIENT_CONTACT_INFORMATION: "GET_CLIENT_CONTACT_INFORMATION",
 SAVE_CLIENT_CONTACT_INFORMATION: "SAVE_CLIENT_CONTACT_INFORMATION",
 SEND_TELEHEALTH_LINK_TO_PROVIDED_CLIENT_CONTACT: "SEND_TELEHEALTH_LINK_TO_PROVIDED_CLIENT_CONTACT",
 CLIENT_PROFILE_FILES_FILTERS: "CLIENT_PROFILE_FILES_FILTERS",
 ALL_CLIENT_FILES_FILTERS: "ALL_CLIENT_FILES_FILTERS",
 GET_TREATMENT_PLANS: "GET_TREATMENT_PLANS",
 SAVE_TREATMENT_PLANS: "SAVE_TREATMENT_PLANS"
}